/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
class r {
  /**
   * @hidden
   */
  constructor(t, e, n, s) {
    this.target = t, this.prevIndex = e, this.nextIndex = n, this.newState = s;
  }
}
export {
  r as SortableOnNavigateEvent
};
